import { SEGMENT_CONTROL_PARTS } from './segmentControlParts';
import type { SegmentControlStyleConfig } from './types';

const BASE_STYLE = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    boxSizing: 'border-box',
    border: '1px solid',
    borderColor: 'separator.border',
    maxWidth: 'fit-content',
    borderRadius: 'md',
    overflowX: 'auto',
    overflowY: 'hidden',
  },
  segmentContainer: {
    display: 'flex',
    flexDirection: 'row',
    _notLast: {
      _after: {
        zIndex: -1,
        content: `'_'`,
        color: 'transparent',
        bg: 'separator.divider',
        w: '0.0625rem',
        marginTop: 'auto',
        marginBottom: 'auto',
      },
    },
    _focus: {
      bg: 'red',
    },
  },
  segmentButton: {
    userSelect: 'none',
    minWidth: 'max-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    cursor: 'pointer',
    fontFamily: 'default',
    fontWeight: 'medium',
    color: 'feature.secondary',
    bg: 'transparent',
    textTransform: 'uppercase',
    boxSizing: 'border-box',
    borderRadius: 'sm',
    _hover: {
      bg: 'interaction.surfaceHover',
    },
    _active: {
      bg: 'interaction.surfaceActive',
    },
    _disabled: {
      cursor: 'not-allowed',
      color: 'interaction.disabled',
      bg: 'transparent',
    },
    _checked: {
      bg: 'interaction.main',
      color: 'feature.onInteraction',
      _disabled: {
        cursor: 'not-allowed',
        bg: 'interaction.disabled',
      },
    },
    _focus: {
      outline: 'none',
      boxShadow: 'focus',
    },
  },
};

const SIZES = {
  sm: {
    container: {
      minHeight: '1.5rem',
      p: '0.0625rem',
    },
    segmentButton: {
      fontSize: 'sm',
      lineHeight: 'sm',
      h: '1.25rem',
      px: '0.625rem',
    },
    segmentContainer: {
      _after: {
        h: '1rem',
      },
    },
  },
  md: {
    container: {
      minHeight: '2rem',
      p: '0.125rem',
    },
    segmentButton: {
      fontSize: 'sm',
      lineHeight: 'sm',
      h: '1.625rem',
      px: '0.875rem',
    },
    segmentContainer: {
      _after: {
        h: '1.25rem',
      },
    },
  },
  lg: {
    container: {
      minHeight: '2.5rem',
      p: '0.125rem',
    },
    segmentButton: {
      fontSize: 'md',
      lineHeight: 'md',
      h: '2.125rem',
      px: '1rem',
    },
    segmentContainer: {
      _after: {
        h: '1.25rem',
      },
    },
  },
};

const DEFAULT_PROPS = {
  size: 'md',
} as const;

export const SEGMENT_CONTROL_STYLE_CONFIG: SegmentControlStyleConfig = {
  parts: SEGMENT_CONTROL_PARTS,
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
